// Terms.jsx
import React from "react";
import Layout from "../../components/user/Layout";

const Terms = () => {
  return (
    <Layout>
      <div className="terms-and-conditions py-22 ps-40 pe-40">
        <h2 className="d-flex justify-content-center fw-bold">Terms and Conditions</h2>

        <section>
          <h5>1. Acceptance of Terms</h5>
          <p>
            By accessing or using the Power Trading Company (“Mobile App” / “Platform”), you agree to be bound by these Terms and Conditions, our <strong>Privacy Policy</strong>, and all applicable laws and regulations, including the <em>Information Technology Act, 2000</em>, <em>Indian Contract Act</em>, <em>GST</em>, and <em>Consumer Protection Laws</em>.
          </p>
          <p>
            This document is an <strong>electronic record</strong> and does not require physical or digital signatures.
          </p>
        </section>

        <section>
          <h5>2. Nature of Services</h5>
          <p>
            The app facilitates online purchase of cement, steel, and other construction materials. Product availability, pricing, and delivery timelines may vary based on location and supplier.
          </p>
        </section>

        <section>
          <h5>3. Eligibility</h5>
          <ul>
            <li>You must be at least <strong>18 years old</strong> or a <strong>legally authorized representative</strong> of a company.</li>
            <li>You confirm that all information provided is <strong>true</strong>, <strong>lawful</strong>, and <strong>accurate</strong>.</li>
          </ul>
        </section>

        <section>
          <h5>4. User Responsibilities</h5>
          <p>You agree to:</p>
          <ul>
            <li>Provide accurate and complete information</li>
            <li>Use the app for lawful commercial purposes only</li>
            <li>Not misuse pricing, payment, or ordering systems</li>
          </ul>
        </section>

        <section>
          <h5>5. Account & Verification</h5>
          <ul>
            <li>You must register using a <strong>mobile number</strong> and <strong>OTP/password</strong>.</li>
            <li><strong>KYC documents</strong> (PAN, GSTIN, Aadhar/CIN) may be required based on user type.</li>
            <li>You are solely responsible for maintaining the <strong>confidentiality</strong> and <strong>security</strong> of your account.</li>
          </ul>
        </section>

        <section>
          <h5>6. Pricing and Payments</h5>
          <ul>
            <li>Prices are displayed exclusive or inclusive of taxes as applicable</li>
            <li>Payments must be made through approved payment methods</li>
            <li>Orders may be cancelled if payment fails or pricing errors occur</li>
          </ul>
        </section>

        <section>
          <h5>7. Orders, Delivery, and Returns</h5>
          <ul>
            <li>Delivery timelines are estimates and depend on logistics and site conditions</li>
            <li>Goods once delivered and accepted are generally non-returnable due to the nature of construction materials, unless damaged or incorrect</li>
          </ul>
        </section>

        <section>
          <h5>8. Cancellations</h5>
          <p>
            Power Trading Company reserves the right to cancel orders due to stock unavailability, pricing errors, or regulatory issues.
          </p>
          <ul>
            <li><strong>Wrong or Damaged Material:</strong> Must be reported within <strong>24 hours</strong> of delivery with photographic & written evidence.</li>
            <li><strong>Cancellation Before Dispatch:</strong> Allowed with deduction of <strong>processing fees</strong>.</li>
            <li><strong>Refunds:</strong> Processed to the original payment method within <strong>10–15 business days</strong> after approval.</li>
          </ul>
        </section>

        <section>
          <h5>9. Limitation of Liability</h5>
          <p>
            We are not liable for indirect losses including project delays, labor costs, or site losses arising from order delays or cancellations.
          </p>
        </section>

        <section>
          <h5>10. Compliance & Usage Restrictions</h5>
          <p><strong>You must not:</strong></p>
          <ul>
            <li>Violate any applicable law (GST, FEMA, IT Act, etc.).</li>
            <li>Upload defamatory, misleading, or unauthorized content.</li>
            <li>Use bots, malware, or unauthorized scrapers.</li>
            <li>Impersonate others or damage Power Trading site / Mobile App infrastructure.</li>
          </ul>
          <p><strong>You must:</strong></p>
          <ul>
            <li>Maintain accurate records.</li>
            <li>Use the Platform lawfully and ethically.</li>
            <li>Follow data privacy, KYC, and anti-fraud protocols.</li>
          </ul>
        </section>

        <section>
          <h5>11. Intellectual Property</h5>
          <ul>
            <li>All content, designs, UI/UX, logos, software, and trademarks are the <strong>exclusive property</strong> of Power Trading Company or its licensors.</li>
            <li>Any unauthorized use, reproduction, redistribution, or commercial application is <strong>strictly prohibited</strong>.</li>
          </ul>
        </section>

        <section>
          <h5>12. Privacy & Data Protection</h5>
          <ul>
            <li>Your data is collected, stored, and shared in compliance with our <strong>Privacy Policy</strong>.</li>
            <li>We may share relevant data with trusted third parties (e.g., payment gateways, logistics providers) to complete your order.</li>
            <li>You may contact our Grievance Officer to raise privacy or misuse-related complaints.</li>
          </ul>
        </section>

        <section>
          <h5>13. Platform Ownership and Access</h5>
          <ul>
            <li>This Platform is owned and operated by <strong>Power Trading Company</strong>, having its registered office at <strong>Tiruchirappalli, Tamil Nadu</strong>.</li>
            <li>We reserve the right to <strong>modify, suspend, or terminate</strong> access at any time <strong>without prior notice</strong>.</li>
          </ul>
        </section>

        <section>
          <h5>14. Governing Law and Jurisdiction</h5>
          <ul>
            <li>These Terms shall be governed by the laws of India. Courts in <strong>Tiruchirappalli, Tamil Nadu</strong> shall have exclusive jurisdiction.</li>
          </ul>
        </section>

        <section>
          <h5>15. Force Majeure</h5>
          <p>
            Power Trading Company shall not be held liable for non-performance caused by:
          </p>
          <ul>
            <li>Natural calamities (e.g., flood, earthquake)</li>
            <li>Government actions or restrictions</li>
            <li>Transportation or supply chain disruptions</li>
            <li>Strikes, wars, pandemics, or other uncontrollable events</li>
          </ul>
        </section>

        <section>
          <h5>16. Termination of Access</h5>
          <p>We may, at our discretion:</p>
          <ul>
            <li>Suspend or block your account for <strong>fraud, non-compliance, or misuse</strong>.</li>
            <li>Hold or reverse payments pending dispute or investigation.</li>
          </ul>
        </section>

        <section>
          <h5>17. Amendments</h5>
          <ul>
            <li>These Terms & Conditions may be <strong>updated without prior notice</strong>.</li>
            <li>It is your responsibility to <strong>review the terms periodically</strong>.</li>
            <li>Continued usage implies <strong>automatic acceptance</strong> of the latest version.</li>
          </ul>
        </section>

        <section>
          <h5>18. Grievance Officer</h5>
          <p>In accordance with the Information Technology Act, 2000 and rules made thereunder:</p>
          <ul>
            <li><strong>Email: info@powergroups.in</strong> </li>
            <li><strong>Working Hours:</strong> Monday to Friday, 10 AM – 6 PM</li>
          </ul>
        </section>

        <section>
          <h5>19. Contact</h5>
          <p>For support or legal queries:</p>
          <p><strong>Power Trading Company</strong></p>
        </section>
      </div>
    </Layout>
  );
};

export default Terms;